// extracted by mini-css-extract-plugin
export default {"container":"Scrollable_container__EqMYz","content":"Scrollable_content__8prcj"};